import { useEffect, type ReactNode } from 'react';
import { useAuth } from '@/shared/auth/useAuth';
import { queueNotification } from '@/shared/ui/AppNotification';

type Props = { children: ReactNode };

export function DjRoute({ children }: Props) {
  const { user } = useAuth();

  const isDj = user?.role === 'DJ' || user?.role === 'ADMIN';

  useEffect(() => {
    if (user && !isDj) {
      // Queue the message to sessionStorage before the full-page redirect so it
      // survives the Cognito logout round-trip and shows on the landing page.
      queueNotification("This account doesn't have DJ access. Please sign in with a DJ account.", 'error');
      window.location.replace('/logout');
    }
  }, [user, isDj]);

  if (!user || !isDj) return null;

  return <>{children}</>;
}
